import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '/services' },
  { label: 'About', href: '/about' },
  { label: 'Insights', href: '/insights' },
  { label: 'Why Choose Us', href: '/why-choose-us' },
  { label: 'Contact', href: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const isActive = (href: string) => location.pathname === href;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || menuOpen ? 'light-glass border-b border-black/[0.06]' : 'bg-white'
      }`}
    >
      <div className="mx-auto px-6 lg:px-10 xl:px-16">
        <div className="flex items-center justify-between h-[64px] lg:h-[72px]">
          <Logo />

          <div className="hidden lg:flex items-center space-x-0.5">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-3.5 py-2 text-[13px] font-medium tracking-[-0.01em] transition-all duration-200 rounded-md whitespace-nowrap ${
                  isActive(link.href)
                    ? 'text-page-ink bg-black/[0.04]'
                    : 'text-page-muted hover:text-page-ink hover:bg-black/[0.04]'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden lg:flex items-center">
            <Link to="/contact" className="btn-primary text-[13px] px-5 py-2">
              Get in Touch
            </Link>
          </div>

          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="lg:hidden p-2 rounded-lg text-page-muted hover:text-page-ink transition-colors cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-lg`} />
            </div>
          </button>
        </div>
      </div>

      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 ${
          menuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
        } border-t border-black/[0.06] bg-white`}
      >
        <div className="px-6 py-4 space-y-0.5">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`flex items-center px-4 py-2.5 text-sm font-medium rounded-lg transition-colors ${
                isActive(link.href)
                  ? 'text-page-ink bg-black/[0.04]'
                  : 'text-page-muted hover:text-page-ink hover:bg-black/[0.04]'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="pt-3 pb-1">
            <Link
              to="/contact"
              className="flex items-center justify-center px-4 py-2.5 bg-[#c97a2b] text-white text-sm font-semibold rounded-md text-center hover:bg-[#b06a22] transition-colors whitespace-nowrap"
            >
              Get in Touch
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
